import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { FILTER_SETS_CELLS } from '../FilterSetsTable.model';
import { getFilterSetTypeText } from '../../../filter-set.utils';

const useCols = ({ type }) => {
  const isProject = type === SAVED_FILTER_SET_TYPES.PROJECT;
  const nameColText = `${getFilterSetTypeText({ type })?.toUpperCase()} NAME`;

  const cols = [
    {
      dataPoint: FILTER_SETS_CELLS.NAME_CELL,
      name: nameColText,
      tableCellProps: { style: { width: '20rem' } },
      sortPoint: 'filterSet.name',
      isSortedCol: true
    },
    {
      dataPoint: FILTER_SETS_CELLS.VIEW_CELL,
      name: 'VIEW',
      sortPoint: 'filterSet.visibility',
      isSortedCol: true
    },
    isProject && {
      dataPoint: FILTER_SETS_CELLS.TAEGET_CELL,
      name: 'TARGET',
      sortPoint: 'dueDateValue',
      isSortedCol: true
    },
    {
      dataPoint: FILTER_SETS_CELLS.OWNER_CELL,
      name: 'OWNER',
      sortPoint: 'filterSet.owner_name',
      isSortedCol: true
    },
    {
      dataPoint: FILTER_SETS_CELLS.ACTIONS_CELL,
      showOnlyOnHover: true,
      tableCellProps: { style: { width: '6rem' } }
    }
  ].filter(Boolean);
  return cols;
};

export default useCols;
